module.exports = __webpack_public_path__ + "img/ION.7e0313a0.svg";